export const config = {
  BASE_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:8100',
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://api.cratehackers.com',
  VERSION: process.env.REACT_APP_VERSION || '0.0.1',
  SPOTIFY_CLIENT_ID:
    process.env.REACT_APP_SPOTIFY_CLIENT_ID ||
    'bc1587cfa3f34a4e896cbe70699964ab',
  TIDAL_CLIENT_ID: process.env.REACT_APP_TIDAL_CLIENT_ID || '',
  TIDAL_CLIENT_SECRET: process.env.REACT_APP_TIDAL_CLIENT_SECRET || '',
  // Apple Music credentials
  APPLE_MUSIC_TEAM_ID: process.env.REACT_APP_APPLE_MUSIC_TEAM_ID || '',
  APPLE_MUSIC_KEY_ID: process.env.REACT_APP_APPLE_MUSIC_KEY_ID || '',
  MUSICAPI_CLIENT_ID: process.env.REACT_APP_MUSICAPI_CLIENT_ID || '',
  MUSICAPI_CLIENT_SECRET: process.env.REACT_APP_MUSICAPI_CLIENT_SECRET || '',
  MUSICAPI_PROXY_URL: process.env.REACT_APP_MUSICAPI_PROXY_URL || '',
  MUSICAPI_ACCOUNT_SLUG: process.env.REACT_APP_MUSICAPI_ACCOUNT_SLUG || '',
  MUSICAPI_CALLBACK_BRIDGE:
    process.env.REACT_APP_MUSICAPI_CALLBACK_BRIDGE || '',
  PIPELINES_API_URL: process.env.REACT_APP_PIPELINES_API_URL || '',
  AUTH_BRIDGE_URL: process.env.REACT_APP_AUTH_BRIDGE_URL || '',
  TIDAL_AUTH_BRIDGE_URL:
    process.env.REACT_APP_TIDAL_AUTH_BRIDGE_URL ||
    process.env.REACT_APP_AUTH_BRIDGE_URL ||
    '',
  // Separate Spotify credentials for Pipelines feature
  PIPELINES_SPOTIFY_CLIENT_ID:
    process.env.REACT_APP_PIPELINES_SPOTIFY_CLIENT_ID || '',
  DEFAULT_TRACK_SEARCH:
    process.env.REACT_APP_DEFAULT_TRACK_SEARCH || 'Bruno Mars – 24K Magic',
  IMAGE_GENERATION_ENDPOINT:
    process.env.REACT_APP_IMAGE_GENERATION_ENDPOINT || '',
  IMAGE_GENERATION_CLIENT_TOKEN:
    process.env.REACT_APP_IMAGE_GENERATION_CLIENT_TOKEN || '',
  IMAGE_GENERATION_OPENAI_KEY:
    process.env.REACT_APP_OPENAI_API_KEY ||
    process.env.REACT_APP_OPENAI_IMAGE_KEY ||
    '',
  IMAGE_GENERATION_OPENAI_MODEL:
    process.env.REACT_APP_OPENAI_IMAGE_MODEL || 'gpt-image-1',
  IMAGE_GENERATION_TEMPLATE_URL:
    process.env.REACT_APP_IMAGE_TEMPLATE_URL ||
    '/assets/templates/crate-cover-template.png',
  IMAGE_GENERATION_TEMPLATE_MASK_URL:
    process.env.REACT_APP_IMAGE_TEMPLATE_MASK_URL || '',
  IMAGE_GENERATION_TEMPLATE_REGION:
    process.env.REACT_APP_IMAGE_TEMPLATE_REGION || '',
  POSTHOG_API_KEY: process.env.REACT_APP_POSTHOG_API_KEY || '',
  POSTHOG_HOST:
    process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  // Supabase project that stores Ask Crate Hackers chat logs (anon key).
  // Telemetry is silently off when either value is missing.
  CHAT_LOGS_URL: process.env.REACT_APP_CHAT_LOGS_URL || '',
  CHAT_LOGS_KEY: process.env.REACT_APP_CHAT_LOGS_KEY || '',
};
